<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      :excel="excel"
      ref="table"
      show-select
      mobile-show-select
      v-model="selected"
    >
     <template v-slot:foot="{ total }">
        <td :colspan="item.headers.length" :style="$isMobile ? '' : 'border-top: #e4e4e4 1px solid'">
          <div class="my-3 mx-4">
            结算总数：<span :class="`${$isMobile ? 'size-20': 'size-27'} blue--text font-family-Impact`">{{total === null ? 0 : total.settleNumber}}</span>个&nbsp;<br v-if="$isMobile">
            结算金额：<span :class="`${$isMobile ? 'size-20': 'size-27'} red--text font-family-Impact`">{{total === null ? 0 : total.payPrice + total.unPayPrice}}</span>元&nbsp;
            已支付：<span :class="`${$isMobile ? 'size-20': 'size-27'} green--text font-family-Impact`">{{total === null ? 0 : total.payPrice}}</span>元&nbsp;
            待支付：<span :class="`${$isMobile ? 'size-20': 'size-27'} warning--text font-family-Impact`">{{total === null ? 0 : total.unPayPrice}}</span>元&nbsp;
          </div>
        </td>
      </template>
      <template v-slot:condition>
        <v-col cols="12" md='2' class="pr-2 pl-0 pt-c-10">
          <v-select
            hide-details="auto"
            outlined dense
            :items="[{ text: '大于0', value: 1 },{ text: '等于0', value: 0 },{ text: '小于0', value: -1 }]"
            label="结算金额"
            v-model="item.params.settleMoney"
            @change="loadData"
            clearable
            clear-icon="mdi-close-circle-outline"
          ></v-select>
        </v-col>
      </template>
      <template v-slot:actions>
        <v-btn depressed dark :small='$isMobile' color="cyan" v-has="'patent-settle-pay'" @click="batchPay" class="mx-1">
          <v-icon size="20" dark>mdi-file-check-outline</v-icon>批量支付
        </v-btn>
      </template>
    </base-material-table>
    <edit-price :item='editPrice' @on-load-data='loadData'></edit-price>
    <v-snackbar v-model="tip.show" timeout='3000' centered rounded="pill" color="warning">
      <span :class="$isMobile ? 'size-13' : 'size-20'">!&nbsp;{{ tip.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text fab v-bind="attrs" small @click="tip.show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { serialNumber } from '@/utils/stringUtil.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { pay, batchPay } from '@/api/order/audit.js'
  import { selectData2 } from '@/utils/tool.js'
  import EditPrice from './EditPrice.vue'

  export default {
    name: 'SettleAudit',
    components: {
      EditPrice
    },
    data() {
      return {
        selected: [],
        channelItems: [],
        specialTypeItems: [],
        tip: { show: false, text: '' },
        editPrice: { show: false, data: {} },
        item: {
          mobile: true,
          total: true,
          path: 'order/audit/settle/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'download', show: true }
          ],
          params: {
            settleMoney: ''
          },
          headers: [
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              value: 'customer.name',
              sortable: false,
              width: 210,
              copy: true,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              copy: true,
              value: 'contract.serialNumber',
              sortable: false,
              width: 210,
              search: { type: 'input', secKey: 'serialNumber' }
            },
            {
              text: '工单状态',
              align: 'center',
              divider: true,
              value: 'orderInfo.orderStatusVal',
              sortable: false,
              mobile: true,
              width: 100,
              search: {
                mobile: true,
                type: 'select',
                secKey: 'orderStatus',
                options: () => [
                  { label: '进行中', value: 2 },
                  { label: '已退回', value: 3 },
                  { label: '已完成', value: 4 },
                  { label: '已通过', value: 5 },
                  { label: '未通过', value: 6 },
                  { label: '已终止', value: -1 },
                ]
              }
            },
            {
              text: '合同总额',
              align: 'center',
              divider: true,
              value: 'contract.signPrice',
              sortable: false,
              mobile: true,
              width: 140
            },
            {
              text: '已收款',
              align: 'center',
              divider: true,
              mobile: true,
              width: 100,
              value: 'contract.returnedMoneys',
              sortable: false,
              formatter: (val) => {
                let money = 0.0
                val.forEach(item => {
                  if (item.order.auditStatus === 1) {
                    money += item.money
                  }
                })
                return money
              }
            },
            {
              text: '资产总额(万元)',
              align: 'center',
              divider: true,
              width: 140,
              value: 'assets',
              sortable: false,
              mobile: true,
            },
            {
              text: '结算金额',
              align: 'center',
              divider: true,
              width: 90,
              mobile: true,
              value: 'payPrice',
              sortable: false
            },
            {
              text: '是否支付',
              align: 'center',
              divider: true,
              width: 90,
              value: 'pay',
              mobile: true,
              sortable: false,
              formatter: (val) => (val === 0 ? '否' : '是'),
              search: {
                mobile: true,
                type: 'select',
                secKey: 'pay',
                options: () => [
                  { label: '否', value: 0 },
                  { label: '是', value: 1 },
                ]
              }
            },
            {
              text: '结算年度',
              align: 'center',
              divider: true,
              width: 100,
              value: 'years',
              sortable: false,
              mobile: true,
              formatter: (val) => val || '--',
              search: {
                type: 'select',
                name: 'year',
                secKey: 'year',
                options: () => selectData2()
              }
            },
            {
              text: '结算类型',
              align: 'center',
              divider: true,
              width: 100,
              value: 'settleType',
              sortable: false,
              mobile: true,
              formatter: (val) => (val === 1 ? '年审' : '专审'),
              search: {
                type: 'select',
                secKey: 'settleType',
                itemText: 'name',
                itemValue: 'id',
                options: () => [{ name: '年审', id: 1},{ name: '专审', id: 2}]
              }
            },
            {
              text: '服务类型',
              align: 'center',
              divider: true,
              width: 200,
              value: 'serviceType',
              sortable: false,
              mobile: true,
              formatter: (val) => (val === 1 ? '只出报告' : val === 2 ? '审计底稿并出具报告' : '只盖章'),
              search: {
                type: 'select',
                secKey: 'serviceType',
                itemText: 'name',
                itemValue: 'id',
                options: () => [{ name: '只出报告', id: 1},{ name: '审计底稿并出具报告', id: 2}]
              }
            },
            {
              text: '专审内容',
              align: 'center',
              divider: true,
              width: 140,
              value: 'specialTypeDic',
              sortable: false,
              mobile: true,
              formatter: (val) => (val ? val.name : '--'),
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'specialTypeId',
                options: () => this.specialTypeItems
              }
            },
            {
              text: '结算渠道',
              align: 'center',
              divider: true,
              width: 150,
              value: 'channelDic.name',
              sortable: false,
              mobile: true,
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'channelId',
                options: () => this.channelItems
              }
            },
            {
              text: '支付时间',
              align: 'center',
              divider: true,
              value: 'settleTime',
              sortable: false,
              width: 120,
              mobile: true,
              search: {
                mobile: true,
                type: 'date',
                secKey: 'settleTimes',
                range: true,
                multiple: true
              },
              formatter: (val) => val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--'
            },
            {
              text: '创建人',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              sortable: false,
              width: 100,
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              sortable: false,
              divider: true,
              width: 120,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '结算备注',
              align: 'center',
              width: 200,
              divider: true,
              value: 'settleRemark',
              sortable: false,
              mobile: true,
              formatter: (val) => val || '--'
            },
            {
              text: '支付备注',
              align: 'center',
              width: 200,
              value: 'payRemark',
              sortable: false,
              mobile: true
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              sortable: false,
              width: 120,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '支付',
                    color: 'primary',
                    icon: 'mdi-charity',
                    onClick: (row) => {
                      this.pay({ id: row.id, pay: 1 })
                    },
                    disable: (row) => row.pay === 1 || row.payPrice === 0 || !this.$_has('audit-settle-pay')
                  },
                  {
                    text: '删除',
                    color: 'warning',
                    icon: 'mdi-delete',
                    onClick: (row, btn) => this.$refs.table.doDelete(row, btn),
                    disable: (row) => !this.$_has('audit-settle-pay') || row.pay === 1
                  },
                  {
                    text: '算金额',
                    color: 'blue',
                    icon: 'mdi-currency-usd',
                    onClick: (row) => {
                      this.editPrice = { show: true, data: row }
                    },
                    disable: (row) => row.pay === 1 || !this.$_has('audit-settle-pay')
                  }
                ]
              }
            }
          ]
        },
        excel: {
          path: 'order/audit/settle/down',
          filename: `${serialNumber()}_审计结算.xls`,
          fields: {
            客户名称: 'customer.name',
            合同单号: 'contract.serialNumber',
            合同总额: 'contract.signPrice',
            已收金额: {
              field: 'contract.returnedMoneys',
              callback: (value) => {
                let money = 0
                value.forEach(mo => {
                  if (mo.order.auditStatus === 1) {
                    money += mo.money
                  }
                })
                return money
              }
            },
            资产总额: 'assets',
            结算数量: 'settleNumber',
            结算金额: 'payPrice',
            是否支付: {
              field: 'pay',
              callback: (val) => (val === 0 ? '否' : '是')
            },
            结算类型: {
              field: 'settleType',
              callback: (val) => (val === 1 ? '年审' : '专审')
            },
            服务类型: {
              field: 'serviceType',
              callback: (val) => (val === 1 ? '只出报告' : val === 2 ? '审计底稿并出具报告' : '只盖章')
            },
            专审内容: 'specialTypeDic.name',
            结算年度: 'years',
            结算渠道: 'channelDic.name',
            结算人员: 'createUser.name',
            结算时间: {
              field: 'createTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            },
            结算备注: 'settleRemark'
          }
        }
      }
    },
    methods: {
      batchPay () {
        if (this.selected.length < 2) {
          this.tip = { show: true, text: '操作失败【至少选择两个结算单】' }
          return
        }
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i].pay === 1) {
            this.tip = { show: true, text: '操作失败【重复申请,包含已支付数据】' }
            return
          }
        }
       this.$dialog.confirm({
          text: `确认批量支付【${this.selected.length}个审计】吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                batchPay(this.selected).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`批量支付成功`, { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      loadData () {
        this.$refs.table.loadData()
      },
       pay (form) {
        const text = '支付'
        this.$dialog.confirm({
          text: `确认${text}吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                pay(form).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`${text}成功`, { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      async getSelectItems () {
        await getByPids(
          {
            pids: [
              this.$constants.auditSettleChannelPid,
              this.$constants.specialTypePid
            ]
          }
          ).then(res => {
            if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.auditSettleChannelPid === result.id) {
                this_.channelItems = result.data
             } else if (this_.$constants.specialTypePid === result.id) {
                this_.specialTypeItems = result.data
             }
           })
          }
        })
      }
    },
    created() {
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
